// extracted by mini-css-extract-plugin
export default {"fields":"RegisterPixChargeModal_fields__07r+z","value":"RegisterPixChargeModal_value__YHtCv"};